"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var scrollTo_1 = require("spry-react/ScrollTo/scrollTo");
function FocusOnRender(props) {
    var htmlRef = React.useRef(null);
    React.useEffect(function () {
        var _a;
        (_a = htmlRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [htmlRef]);
    return React.createElement("span", { tabIndex: -1, ref: htmlRef, style: { outline: 'none' } }, props.children);
}
exports.FocusOnRender = FocusOnRender;
function ScrollToAndFocusOnRender(props) {
    return React.createElement(React.Fragment, null,
        React.createElement(scrollTo_1.ScrollToOnRender, null),
        React.createElement(FocusOnRender, null, props.children));
}
exports.ScrollToAndFocusOnRender = ScrollToAndFocusOnRender;
